export const hotel = {
  HotelDimensionPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'CampaignHotelId',
      'AdvertiserHotelId',
      'HotelName',
      'Country',
      'City',
      'State',
      'Brand',
      'StarRating',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'Revenue',
    ],
    mandatory: [
      'Impressions',
    ],
    linechartDefault: [
    ],
    barchartDefault: [
    ],
  },
  HotelGroupPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'HotelGroup',
      'PartitionType',
      'CampaignHotelId',
      'AdvertiserHotelId',
      'HotelName',
      'Country',
      'City',
      'State',
      'Brand',
      'StarRating',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'Revenue',
    ],
    mandatory: [
      'Impressions',
    ],
    linechartDefault: [
    ],
    barchartDefault: [
    ],
  },
};

